export default __webpack_public_path__ + "static/media/bit8.6880621a.svg";